import { getWidgetIdFromWidgetName, getWidgetNameFromWidgetId, } from '@wix/members-area-app-definitions';
const extractUniqueRouteFields = (routes) => {
    const paths = new Set();
    const states = new Set();
    const vfrValues = new Set();
    routes.forEach((route) => {
        if (route.path) {
            paths.add(route.path);
        }
        if (route.state) {
            states.add(route.state);
        }
        if (route.vfr) {
            route.vfr.forEach((role) => vfrValues.add(role));
        }
    });
    return {
        paths: Array.from(paths),
        states: Array.from(states),
        vfrValues: Array.from(vfrValues),
    };
};
export const encodeRoutes = (routes, options) => {
    const validRoutes = routes.filter((route) => {
        return !!(route.path &&
            route.state &&
            route.widgetId &&
            getWidgetNameFromWidgetId(route.widgetId) !== undefined);
    });
    if (routes.length !== validRoutes.length && options?.log) {
        options.log('Routes compression: some routes were filtered out', {
            routes: JSON.stringify(routes),
        });
    }
    const { paths, states, vfrValues } = extractUniqueRouteFields(routes);
    const data = validRoutes.map((route) => {
        const compressed = {
            p: paths.indexOf(route.path),
            s: states.indexOf(route.state),
            w: getWidgetNameFromWidgetId(route.widgetId),
        };
        if (route.home) {
            compressed.h = 1;
        }
        if (route.private === true) {
            compressed.r = 1;
        }
        if (route.private === false) {
            compressed.r = 0;
        }
        if (route.vfr) {
            compressed.v = route.vfr.map((role) => vfrValues.indexOf(role));
        }
        return compressed;
    });
    return { version: 1, paths, states, vfrValues, data };
};
export const decodeRoutes = (compressed) => {
    const { paths, states, vfrValues, data } = compressed;
    return data.map((item) => {
        const route = {
            path: paths[item.p],
            state: states[item.s],
            widgetId: getWidgetIdFromWidgetName(item.w),
        };
        if (item.h) {
            route.home = true;
        }
        if (item.r === 1) {
            route.private = true;
        }
        if (item.r === 0) {
            route.private = false;
        }
        if (item.v) {
            route.vfr = item.v.map((idx) => vfrValues[idx]);
        }
        return route;
    });
};
export const isCompressedData = (data) => {
    return (!!data &&
        !Array.isArray(data) &&
        typeof data === 'object' &&
        data.version === 1);
};
//# sourceMappingURL=index.js.map